import {Panes} from "../../controllers/panes";
import {AppPane, ContainingPane, IAppConfig, BaseAppConfig} from "./app_config";
import {Extent} from "ol/extent";
import {L} from "../../lt-ng/landcare-toolkit";
import Item = L.tree.Item;
import isQueryAble = L.tree.isQueryAble;
import {IBaseGeoAppScope} from "../../controllers/IBaseGeoAppScope";
import {ISharedFeatureControlState, ReportKind} from "../ISharedFeatureState";
import getVisibleScienceLayers = L.tree.getVisibleScienceLayers;
import {GeoAppEvents} from "../../controllers/events/geoapp_events";
import {LTServices} from "../../lt-ng/lt-services";
import IMapService = LTServices.IMapService;
import getIncludedScienceLayers = L.tree.getIncludedScienceLayers;
import {ILayerTreeManipulationService} from "../oe/layer-tree-manipulation";
import {StateService} from "@uirouter/angularjs";
import {IStateLayerParams, StateNames} from "../../router/oe-layers-router";


export class OEAppConfig extends BaseAppConfig implements IAppConfig {
    public static $inject = ['$location', '$injector', '$state'];

    constructor(protected $location: ng.ILocationService,
            protected $injector: ng.auto.IInjectorService,
            protected $state: StateService,) {
        super();
    }

    printModuleApplication(): string {
        return 'environment_theme';
    }

    includeItemsByDefault(): boolean {
        return false;
    }

    expandGroupsByDefault(): boolean {
        return false;
    }

    multiplePinsInRHP(): boolean {
        return false;
    }

    tourURL(): string {
        throw new Error("Not yet implemented");
    }

    layerExtent: Extent = [846720, 4426240, 2365440, 6496000];

    getContainingPane(pane: AppPane): ContainingPane {
        switch (pane) {
            case "Search": return 'paneLeftCollapsed';
            case "Layers": return 'paneLeftCollapsed';
            case "Pins": return 'paneLeftCollapsed';
            case "Metadata": return 'paneBottomCollapse';
            case "Overview": return 'paneBottomCollapse';
            case "Legend": return 'paneBottomCollapse';
            case "Features": return 'paneRightCollapse';
            case "Properties": return 'paneRightCollapse';
            case "SoilSummary": return 'paneRightCollapse';
            default: return null;
        }
    }

    isSingleClickAddPin(): boolean {
        return true;
    }

    isSingleClickActive(sharedState: ISharedFeatureControlState): boolean {
        if (sharedState.featureMode && sharedState.featureMode !== "pin") return false;

        const activeReport = sharedState.activeReport;
        return !activeReport || [ReportKind.pin, ReportKind.multiplePin].includes(activeReport.kind);
    }

    getApplication() {
        return 'oe_v2';
    }

    initGeoApp($scope: IBaseGeoAppScope): void {
        if (!window.localStorage.getItem('termsShown')) {
            $scope.showTermsModal();
        }

        const mapService: IMapService = this.$injector.get('landcareMapService');
        const layerTreeManipulationService: ILayerTreeManipulationService = this.$injector.get('layerTreeManipulationService');

        /*let getIncluded = (nodes: Item[]) => nodes.filter((n) =>
            n.extraState.metaLayerSelector.checked);*/

        let updateIncludedLayers = () => {
            const treeData = mapService && mapService.treeData || [];
            let visible = getVisibleScienceLayers(treeData)
                .filter(l => !l.isCustom);

            if (!visible.length) {
                /**
                 * Show the first included layer and expand the tree to highlight it
                 */
               /* let included = getIncluded(treeData);

                let toExpandAndSelect = [];

                while(included.length) {
                    let node = included[0];
                    if (!node.classId) {
                        toExpandAndSelect.push(node);
                    }
                    included = getIncluded(node.children || []);
                }

                toExpandAndSelect.forEach((node, i) => {
                    node.expanded = true;
                    node.checked = true;
                    node.isChecked();
                    if (i == toExpandAndSelect.length-1) {
                        $scope.showSelected(node, true, false);
                    }
                });*/
            } else {
                // Expand the tree to show any active layers
                let item = visible.pop();
                while (item) {
                    item.expanded = true;
                    item = item.parent;
                }
            }

            $scope.$root.$broadcast(GeoAppEvents.treeChange, true);
        }

        $scope.$on(GeoAppEvents.toggleLayerSelector, (ev, onOrOff, fromUser, eagerForLayers) => {
            if (eagerForLayers !== undefined) {
                this.eagerForLayers = eagerForLayers;
            }

            if (onOrOff || !this.eagerForLayers) {
                return;
            }

            this.eagerForLayers = false;
            updateIncludedLayers();

            const visible = getVisibleScienceLayers(mapService.treeData)
                .filter(l => !l.isCustom);

            const includedScience = getIncludedScienceLayers(mapService.treeData);

            if (!visible.length && includedScience.length) {
                let l = includedScience[0];
                let group = l.parent.name;

                const stateParams: IStateLayerParams = {
                    group,
                    layers: l.layerService.layerName,
                    contextLayers: undefined,
                };

                this.$state.go(StateNames.layers, stateParams, { custom: {} });
            }
        });

        $scope.$on(GeoAppEvents.eagerForLayers, (ev, onOrOff) => {
            this.eagerForLayers = onOrOff;
        })

        $scope.$on('layerSelector:updateIncludedLayers', updateIncludedLayers);
    }

    pointQueryPane: string = Panes.Ids.FEATURES;
    deselectPinOnPaneClose: boolean = false;

    getLayersForPointQuery(treeDate: Item | Item[], reportingLayers: Item[] = []): Item[] {
        return reportingLayers.filter(isQueryAble);
    }

    eagerForLayers: boolean = true;
}
